import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Admin from './Admin';
import reportWebVitals from './reportWebVitals';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '40px', fontFamily: 'monospace', background: '#fff', color: '#c00', maxWidth: '800px', margin: '60px auto', border: '2px solid #c00', borderRadius: '8px' }}>
          <h2>App crashed — error details:</h2>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', marginTop: '16px', fontSize: '13px' }}>
            {this.state.error.toString()}
            {'\n\n'}
            {this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const isAdmin = window.location.pathname.startsWith('/admin');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {isAdmin ? <Admin /> : <App />}
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
